import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setAssignments, setProjectsAssignments, setJudgesAssignments } from '../../redux/judgingSetup/actions';
import JudgingRoundJudgeAssignment from './JudgingRoundJudgeAssignment';
import JudgingRoundProjectAssignment from './JudgingRoundProjectAssignment';
import JudgingAssignmentLoad from './JudgingAssignmentLoad';
import JudgingRoundSetup from './JudgingRoundSetup';
import { store } from '../../redux/oldStore';
import { toast } from 'react-toastify';
import Modal from '../Modal/Modal';
import EditAssignment from './EditAssignment';
import JudgingJudgeAssignmentModal from './JudgingJudgeAssignmentModal';
import JudgingProjectAssignmentModal from './JudgingProjectAssignmentModal';
import { ServerResponse } from '../../utils/Server';
import { IJudgeGroupAssignment, IJudgingManagementProject, IRoundAssignmentMangement } from './JudgingInfoDataTypes';
import { IAutoAssignRunSnapshot } from './JudgingCircles/JudgingCirlcesTypes';
import JudgeGroupManager from './JudgeGroup/JudgeGroupManager';
import Button from '../_Core/Button';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import JudgeGroupAssignmentModal from './JudgeGroupAssignmentModal';
import { IListItem } from '../_Core/CoreTypes';
import { IState } from '../../redux/redux';

interface IProps extends IJudgingActions {
  roundIndex: any;
  round: any;
  projects: any;
  categories: any;
  divisions: any;
  judges: any;
  participants?: any[];
  exit: () => void;
  judgesByKey: any;
  projectsByKey: any;
  categoryDic: Record<number, string>;
  divisionDic: Record<number, string>;
  state: IState;
  roundSettings: any;
}

const JudgingRoundDetails = (props: IProps) => {
  const [data, setData] = useState<IRoundAssignmentMangement>();
  const [assignmentDic, setAssignmentDic] = useState<Record<string, IJudgeGroupAssignment[]>>({});
  const [judgeGroupDic, setJudgeGroupDic] = useState<Record<string, IListItem>>({});
  const [projectDic, setProjectDic] = useState<Record<number, IJudgingManagementProject>>({});
  const [projectSearchValue, setProjectSearchValue] = useState('');
  const [judgeSearchValue, setJudgeSearchValue] = useState('');
  const [thisProjects, setThisProjects] = useState([]);
  const [thisJudges, setThisJudges] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [filteredJudges, setFilteredJudges] = useState([]);
  const [selectedAssignment, setSelectedAssignment] = useState<any>();
  const [editAssignmentOpen, setEditAssignmentOpen] = useState(false);
  const [roundProjectsDict, setRoundProjectsDict] = useState<any>({});
  const [roundJudgesDict, setRoundJudgesDict] = useState<any>({});
  const [assignmentModalShow, setAssignmentModalShow] = useState(false);
  const [selectedProject, setSelectedProject] = useState<any>({});
  const [selectedJudge, setSelectedJudge] = useState<any>({});
  const [selectedJudgeGroup, setSelectedJudgeGroup] = useState<any>();
  const [autoAssignHistory, setAutoAssignHistory] = useState<IAutoAssignRunSnapshot[]>([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    getAssignments();
  }, []);

  useEffect(() => {
    let pa = {};
    props.assignments.forEach((x) => {
      if (!pa[x.ProjectId]) pa[x.ProjectId] = [];
      pa[x.ProjectId].push(x);
    });
    props.setProjectsAssignments(pa);

    let ja = {};
    props.assignments.forEach((x) => {
      if (!ja[x.JudgeId]) ja[x.JudgeId] = [];
      ja[x.JudgeId].push(x);
    });
    props.setJudgesAssignments(ja);
  }, [props.assignments]);

  useEffect(() => {
    let theseProjects = props.projects.filter((proj) => roundProjectsDict[proj.ProjectKey]);
    setThisProjects(theseProjects);
  }, [props.projects, roundProjectsDict]);

  const isPeerReview = !!props.round?.Values?.IsPeerReview;

  useEffect(() => {
    const pool = isPeerReview && props.participants?.length ? props.participants : props.judges;
    let theseJudges = pool.filter((judge) => roundJudgesDict[judge.PublicId]);
    setThisJudges(theseJudges);
  }, [props.judges, props.participants, roundJudgesDict, isPeerReview]);

  useEffect(() => {
    let value = projectSearchValue.toLowerCase().trim();
    if (value.length === 0) {
      return setFilteredProjects(thisProjects);
    }
    return setFilteredProjects(thisProjects.filter((project) => project.ProjectId.toLowerCase().includes(value) || project.Title.toLowerCase().includes(value)));
  }, [thisProjects, projectSearchValue]);

  useEffect(() => {
    let value = judgeSearchValue.toLowerCase().trim();
    if (value.length === 0) {
      return setFilteredJudges(thisJudges);
    }
    return setFilteredJudges(thisJudges.filter((judge) => `${judge.FirstName} ${judge.LastName}`.toLowerCase().includes(value)));
  }, [thisJudges, judgeSearchValue]);

  useEffect(() => {
    if (data?.projects?.length > 0) {
      let projectDict = data.projects.reduce((dict, string) => {
        return { ...dict, [string]: true };
      }, {});
      setRoundProjectsDict(projectDict);
    }
  }, [data?.projects]);

  useEffect(() => {
    const incoming = data?.roundDetails?.AutoAssignHistory;
    if (incoming?.length) {
      setAutoAssignHistory(incoming);
    }
  }, [data?.roundDetails?.AutoAssignHistory]);

  useEffect(() => {
    if (data?.judges.length > 0) {
      let judgeDict = data.judges.reduce((dict, string) => {
        return { ...dict, [string]: true };
      }, {});
      setRoundJudgesDict(judgeDict);
    }
  }, [data?.judges]);

  const removeAssignment = (assignmentId) => {
    let [assignment] = props.assignments.filter((assignment) => assignment.Id === assignmentId);
    if (!assignment) return;
    let judge = props.judgesByKey[assignment.JudgeId];
    if (!judge) return;
    let project = props.projectsByKey[assignment.ProjectId];
    if (!window.confirm(`Are you sure you want to remove this assignment from ${judge.FirstName} ${judge.LastName} to judge ${project.ProjectId}?`)) {
      return;
    }
    let cb = () => {
      props.setAssignments(props.assignments.filter((assignment) => assignment.Id !== assignmentId));
    };
    store.server
      .postApi('../JudgingManagement/RemoveAssignment', {
        assignmentId: assignmentId,
      })
      .then((res) => {
        console.log(res);
        cb();
      })
      .catch((err) => {
        console.error(err);
        toast.warning('something went wrong');
      });
  };

  const editAssignment = (assignmentId) => {
    let [assignment] = props.assignments.filter((assignment) => assignment.Id === assignmentId);
    if (!assignment) return;

    let judge = props.judgesByKey[assignment.JudgeId];
    if (!judge) return;
    let project = props.projectsByKey[assignment.ProjectId];

    //open
    setSelectedAssignment(assignment);
    setEditAssignmentOpen(true);
    setSelectedJudge(judge);
    setSelectedProject(project);
    setSelectedJudgeGroup(undefined);
    //create modal...
  };

    const uniqueFilteredProjects = filteredProjects.reduce((acc, project) => {
    const exists = acc.some(p => p.ProjectId === project.ProjectId);
    return exists ? acc : [...acc, project];
    }, []);

  const mappedFilteredProjects = uniqueFilteredProjects.map((project, index) => {
    return (
      <JudgingRoundProjectAssignment
        key={`${project.ProjectId}${index}`}
        project={project}
        assignments={props.projectsAssignments[project.ProjectIntId] || []}
        judges={props.judgesByKey}
        round={props.round}
        setModalOpen={setAssignmentModalShow}
        setSelectedProject={setSelectedProject}
        setSelectedJudge={setSelectedJudge}
        removeAssignment={removeAssignment}
        editAssignment={editAssignment}
      />
    );
  });

  const reassignJudge = (fromJudgeId, toJudgeId) => {
    store.server
      .postApi<ServerResponse<any>>('../JudgingManagement/ReassignJudge', {
        fromJudgeId,
        toJudgeId,
        roundId: props.round.Id,
      })
      .then((res) => {
        if (res.Success) {
          toast.success('Assignments reassigned.');
          getAssignments();
        } else {
          toast.error(res.Message, { autoClose: false });
        }
      });
  };

  const mappedFilteredJudges = filteredJudges.map((judge, index) => {
    return (
      <JudgingRoundJudgeAssignment
        categories={props.categoryDic}
        divisions={props.divisionDic}
        key={`${judge.Id}${index}`}
        projects={props.projectsByKey}
        assignments={props.judgesAssignments[judge.Id]}
        judge={judge}
        round={props.round}
        allJudges={thisJudges}
        setModalOpen={setAssignmentModalShow}
        setSelectedProject={setSelectedProject}
        setSelectedJudge={setSelectedJudge}
        removeAssignment={removeAssignment}
        editAssignment={editAssignment}
        reassignJudge={reassignJudge}
      />
    );
  });

  const getAssignments = () => {
    let request = {
      roundId: props.round.Id,
    };
    store.server
      .postApi<ServerResponse<IRoundAssignmentMangement>>('../JudgingManagement/RoundAssignments', request)
      .then((res) => {
        const dic = {};
        res.Value.judgeGroupAssignments?.forEach((x) => {
          let pKey = `p-${x.ProjectId}`;
          let jKey = `j-${x.JudgeGroupId}`;

          if (!dic[pKey]) dic[pKey] = [];
          dic[pKey].push(x);

          if (!dic[jKey]) dic[jKey] = [];
          dic[jKey].push(x);
        });
        setAssignmentDic(dic);

        const jgDic = {};
        res.Value.judgeGroups?.forEach((x) => {
          jgDic[x.id] = x;
        });
        setJudgeGroupDic(jgDic);

        const pDic = {};
        props.projects?.forEach((x) => {
          pDic[x.ProjectIntId] = x;
        });
        setProjectDic(pDic);

        props.setAssignments(res.Value.Assignments ?? []);
        setData(res.Value);
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      {props.round && (
        <div>
          <div className="flex-between">
            <div className="">
              <h3>{props.round.Name}</h3>
              Round Value: {props.round.RoundValue}
            </div>
            <div className="">
              <span className="hover-danger" onClick={props.exit}>
                <i className="fad fa-2x fa-portal-exit"></i>
                Close
              </span>
            </div>
          </div>
          <hr />
          <div className="head-room"></div>
          <div>
            <Tabs>
              <TabList>
                {data?.roundDetails.UseJudgeGroups ? (
                  <>
                    <Tab>
                      <i className="fad fa-box-full"></i>
                      Entries / Projects
                    </Tab>
                    <Tab>
                      <i className="fad fa-balance-scale-right"></i>
                      Judge Groups Assignments
                    </Tab>
                    <Tab>
                      <i className="fad fa-balance-scale-right"></i>
                      Judging Groups
                    </Tab>
                  </>
                ) : (
                  <>
                    <Tab>
                      <i className="fad fa-box-full"></i>
                      Entries / Projects
                    </Tab>
                    <Tab>
                      <i className="fad fa-balance-scale-right"></i>
                      {isPeerReview ? 'Reviewers' : 'Judges'}
                    </Tab>
                <Tab>
                  <i className="fad fa-cogs"></i>
                  {isPeerReview ? 'Auto Assign Peer Review' : 'Auto Assign Judges'}
                </Tab>
                <Tab>
                  <i className="fad fa-cloud-upload"></i>
                  Load Assignments
                </Tab>
                  </>
                )}
              </TabList>
              {data?.roundDetails.UseJudgeGroups ? <>
              
                <TabPanel>
                <div className="head-room"></div>
                <div className="flex-between">
                  <div>
                    <h3>Entries</h3> Below is listed all of the projects and their assignments for this round. You can add or remove assignments for each project.
                  </div>
                </div>
                {filteredProjects?.map((x, i) => {
                  return (
                    <div key={`pj-${i}`} className="hover-shadow row-padding soft-border">
                      <div className="flex-between">
                        <div>
                          <strong>{x.ProjectId}</strong> <span dangerouslySetInnerHTML={{ __html: x.Title }} />
                        </div>
                        <div>
                          <Button type="new" onClick={() => {
                            setSelectedProject(x);
                            setSelectedJudgeGroup(undefined);
                            setSelectedAssignment(undefined); 
                            setAssignmentModalShow(true);
                          }} text="New Assignment" />
                        </div>
                      </div>
                      <div className='judging-assignment-list'>
                        {assignmentDic[`p-${x.ProjectIntId}`]?.map((a, i) => {
                          return <div className='judge-assignment' key={`a-${i}`}
                          onClick={() => {
                            setSelectedProject(x);  
                            setSelectedJudgeGroup(undefined);
                            setSelectedAssignment(a); 
                            setAssignmentModalShow(true);
                          }}
                          >{judgeGroupDic[a.JudgeGroupId+'']?.name ?? 'Unknown'}</div>
                          })}
                      </div>
                    </div>
                  );
                })}
              </TabPanel>
              <TabPanel>
                {thisProjects ? (
                  <div>
                    <div className="flex-between">
                      <div>
                        <h3>Group Assignments</h3> Below is listed all of the judge groups and their assignments for this round. You can add or remove assignments for each group.
                      </div>
                      <div></div>
                    </div>
                    {data?.judgeGroups?.map((x, i) => {
                      return (
                        <div key={`jg-${i}`} className="hover-shadow row-padding soft-border">
                          <div className="flex-between">
                            <div>
                              <strong>{x.name}</strong>
                            </div>
                            <div>
                              <Button type="new" onClick={() => {
                                setSelectedProject({});
                                setSelectedAssignment(undefined);
                                setSelectedJudgeGroup(x);
                                setAssignmentModalShow(true);
                              }} text="New Assignment" />
                            </div>
                          </div>
                      <div className='judging-assignment-list'>
                        {assignmentDic[`j-${x.id}`]?.map((a, i) => {
                          return <div className='judge-assignment' key={`a-${i}`}
                          onClick={() => {
                            setSelectedProject({});  
                            setSelectedJudgeGroup(x);
                            setSelectedAssignment(a); 
                            setAssignmentModalShow(true);
                          }}
                          >{projectDic[a.ProjectId]?.ProjectId ?? 'Unknown'}</div>
                          })}
                      </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    <div className="head-room"></div>
                    <h1 className="text-muted">
                      <i className="fad fa-spinner fa-spin"></i>Loading...
                    </h1>
                    <div className="head-room"></div>
                  </div>
                )}
              </TabPanel>
              <TabPanel>
                <div className="head-room"></div>
                <JudgeGroupManager />
              </TabPanel>
              </>
              :
              <>
              <TabPanel>
                {thisProjects ? (
                  <div>
                    <div className="flex-between">
                      <div>
                        <h3>Entries</h3> With their judging assignments for this round. You can add additional judges to a project by clicking on the <i className="fad fa-user-plus"></i> icon.
                      </div>
                      <div>
                        <div className="input-group">
                          <input
                            // v-model="projectSearchValue"
                            onChange={(e) => setProjectSearchValue(e.target.value)}
                            className="form-control"
                            id="z-index-control1"
                            placeholder="search"
                          />
                          <span className="input-group-addon">
                            <i className="fa fa-search"></i>
                          </span>
                        </div>
                      </div>
                                              </div>
                    {mappedFilteredProjects}
                  </div>
                ) : (
                  <div>
                    <div className="head-room"></div>
                    <h1 className="text-muted">
                      <i className="fad fa-spinner fa-spin"></i>Loading...
                    </h1>
                    <div className="head-room"></div>
                  </div>
                )}
              </TabPanel>
              <TabPanel>
                {thisJudges ? (
                  <div>
                    <div className="flex-between">
                      <div>
                        <h3>Judges</h3> With their judging assignments for this round. You can add additional projects to a judge by clicking on the <i className="fad fa-box-open"></i> icon.
                      </div>
                      <div>
                        <div className="input-group">
                          <input
                            // v-model="judgeSearchValue"
                            onChange={(e) => setJudgeSearchValue(e.target.value)}
                            className="form-control "
                            id="z-index-control2"
                            placeholder="search"
                          />
                          <span className="input-group-addon">
                            <i className="fa fa-search"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    {mappedFilteredJudges}
                  </div>
                ) : (
                  <div>
                    <div className="head-room"></div>
                    <h1 className="text-muted">
                      <i className="fad fa-spinner fa-spin"></i>Loading...
                    </h1>
                    <div className="head-room"></div>
                  </div>
                )}
              </TabPanel>
              <TabPanel>
                <div className="head-room"></div>
                <JudgingRoundSetup
                  judges={thisJudges || []}
                  round={props.round}
                  categories={props.categories || []}
                  divisions={props.divisions || []}
                  projectsByCategory={props.projectsByCategory}
                  projects={thisProjects || []}
                  setAssignments={props.setAssignments}
                  judgingSessions={data?.JudgingSessions ?? []}
                  Settings={props.roundSettings}
                  autoAssignHistory={autoAssignHistory}
                  setAutoAssignHistory={setAutoAssignHistory}
                />
              </TabPanel>
              <TabPanel>
                <div className="head-room"></div>
                <JudgingAssignmentLoad
                  judges={thisJudges || []}
                  round={props.round}
                  categories={props.categories || []}
                  divisions={props.divisions || []}
                  projectsByCategory={props.projectsByCategory}
                  projects={thisProjects || []}
                  setAssignments={props.setAssignments}
                  judgingSessions={data?.JudgingSessions ?? []}
                />
                <div className="head-room"></div>
              </TabPanel>
              </>}
            </Tabs>
          </div>
        </div>
      )}
      {editAssignmentOpen && (
        <Modal setModalOpen={setEditAssignmentOpen} title="Edit Assignment">
          <div>
            <EditAssignment
              projects={thisProjects}
              projectsByKey={props.projectsByKey}
              judgesByKey={props.judgesByKey}
              judges={thisJudges}
              assignments={props.assignments}
              round={props.round}
              selectedAssignment={selectedAssignment}
              setAssignments={props.setAssignments}
              setModalOpen={setEditAssignmentOpen}
              removeAssignment={removeAssignment}></EditAssignment>
          </div>
        </Modal>
      )}
      {assignmentModalShow && (
        <Modal
          setModalOpen={setAssignmentModalShow}
          size="m"
          title={selectedJudge.Id ? `${selectedJudge.FirstName} ${selectedJudge.LastName}` : selectedProject.ProjectId && `${selectedProject.ProjectId}`}>
          {selectedProject.ProjectId && data.roundDetails.UseJudgeGroups ? (
            <JudgeGroupAssignmentModal
              focus="project"
              focusId={selectedProject.ProjectIntId}
              projects={thisProjects}
              judgeGroups={data.judgeGroups}
              assignments={data.judgeGroupAssignments  || []}
              roundDetails={data.roundDetails}
              roundId={props.round.Id}
              assignment={selectedAssignment}
              onSave={(x) => {
                getAssignments();
                setAssignmentModalShow(false);
              }}
              onRemoved={(x) => {
                getAssignments();
                setAssignmentModalShow(false);
              }}

              />
          ) : selectedProject.ProjectId ? (
            <div>
              <JudgingProjectAssignmentModal
                project={selectedProject}
                assignments={selectedProject.assignments || []}
                judges={thisJudges}
                judgesByKey={props.judgesByKey}
                round={props.round}
                fullAssignments={props.assignments}
                setAssignments={props.setAssignments}
                setModalOpen={setAssignmentModalShow}
              />
            </div>
          ) : selectedJudgeGroup && data.roundDetails.UseJudgeGroups ? (
            <JudgeGroupAssignmentModal
            focus="judgeGroup"
            focusId={selectedJudgeGroup.id}
            projects={thisProjects}
            judgeGroups={data.judgeGroups}
            assignments={data.judgeGroupAssignments || []}
            roundDetails={data.roundDetails}
            roundId={props.round.Id}
            assignment={selectedAssignment}
            onSave={(x) => {
              getAssignments();
              setAssignmentModalShow(false);
            }}
            onRemoved={(x) => {
              getAssignments();
              setAssignmentModalShow(false);
            }}
            />
          ) : (
            <div>
              <JudgingJudgeAssignmentModal
                judge={selectedJudge}
                assignments={props.judgesAssignments[selectedJudge.Id] || []}
                projects={thisProjects}
                projectsByKey={props.projectsByKey}
                round={props.round}
                fullAssignments={props.assignments}
                setAssignments={props.setAssignments}
                setModalOpen={setAssignmentModalShow}
              />
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (reduxState) => {
  return reduxState.judgingSetup;
};
const actions = {
  setAssignments,
  setProjectsAssignments,
  setJudgesAssignments,
};

export default connect(mapStateToProps, actions)(JudgingRoundDetails);
//export default ReduxMap(connect(mapStateToProps, actions)(JudgingRoundDetails));

interface IJudgingActions {
  setProjects?: Function;
  setProjectsByKey?: Function;
  setProjectsByCategory?: Function;
  setCategories?: Function;
  setRounds?: Function;
  setJudges?: Function;
  setJudgesByKey?: Function;
  setPage?: Function;
  setSelectedRoundIndex?: Function;
  setSelectedRound?: Function;
  setSelectedProject?: Function;
  setSelectedJudge?: Function;
  setAssignments?: Function;
  setProjectsAssignments?: Function;
  setJudgesAssignments?: Function;
  setJudgingRoundEditModalShow?: Function;
  setAssignmentModalShow?: Function;
  projects?: any;
  categories?: any;
  rounds?: any;
  selectedRound?: any;
  selectedRoundIndex?: any;
  page?: any;
  selectedProject?: any;
  selectedJudge?: any;
  judges?: any;
  judgesByKey?: any;
  projectsByKey?: any;
  projectsByCategory?: any;
  assignments?: any;
  projectsAssignments?: any;
  judgesAssignments?: any;
  judgingRoundEditModalShow?: any;
  assignmentModalShow?: any;
}
